<script lang="ts">
    import Router from 'svelte-spa-router'
    import { wrap } from 'svelte-spa-router/wrap'
    import type ServiceProvider from '../services/service.provider'
    import type DataProvider from '../services/data.provider'

    export let serviceProvider: ServiceProvider
    export let dataProvider: DataProvider

    const propsWrapper = (componentFile: any): any => {
        return wrap({
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            asyncComponent: componentFile,
            props: {
                serviceProvider,
                dataProvider,
            },
        })
    }

    const routes = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        "/": propsWrapper(() => import("./ActivitySelector.svelte")),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        "/skupina/:id": propsWrapper(() => import("./ActivitySelector.svelte")),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        "/sluzba/:id": propsWrapper(() => import("./DateTimeSelector.svelte")),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        "/kontakt": propsWrapper(() => import("./ContactInformation.svelte")),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        "/odeslano": propsWrapper(() => import("./Success.svelte")),

        // en
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        "/group/:id": propsWrapper(() => import("./ActivitySelector.svelte")),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        "/service/:id": propsWrapper(() => import("./DateTimeSelector.svelte")),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        "/contact": propsWrapper(() => import("./ContactInformation.svelte")),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        "/sent": propsWrapper(() => import("./Success.svelte")),
    }
</script>

<Router {routes}/>
